import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WatchCarouselComponent } from './watch-carousel.component'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { SvgModule } from '../../shared/svg/svg.module'

@NgModule({
  imports: [CommonModule, SvgModule, AnalyticsModule],
  exports: [WatchCarouselComponent],
  declarations: [WatchCarouselComponent]
})
export class WatchCarouselModule {}
